var _excluded = ["locality", "layout"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import isEmpty from 'lodash/isEmpty';
import AllhomesListingSuburbStats from './allhomes-listing-suburb-stats';
import AllhomesListingSuburbStatsMobile from './allhomes-listing-suburb-stats-mobile';
import { SuburbSummaryGraphQL } from './components/suburb-summary';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment SuburbStats on Division {\n    name\n    profile {\n      medianSalePrices {\n        units {\n          period\n          medianPrice\n        }\n        nonUnits {\n          period\n          medianPrice\n        }\n      }\n    }\n    ...SuburbSummary\n  }\n\n  ", "\n"])), SuburbSummaryGraphQL.fragment);
var graphQLToProps = function graphQLToProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$division = _ref.division,
    division = _ref$division === void 0 ? {} : _ref$division;
  var profile = (division === null || division === void 0 ? void 0 : division.profile) || {};
  var medianSalePrices = profile.medianSalePrices || {};
  return _objectSpread(_objectSpread({}, SuburbSummaryGraphQL.graphQLToProps({
    division
  })), {}, {
    medianPriceData: !isEmpty(medianSalePrices.nonUnits) || !isEmpty(medianSalePrices.units) ? {
      labels: medianSalePrices.nonUnits.map(item => "".concat(item.period)),
      datasets: [{
        label: 'Houses',
        data: medianSalePrices.nonUnits.map(item => item.medianPrice)
      }, {
        label: 'Units',
        data: medianSalePrices.units.map(item => item.medianPrice)
      }]
    } : null
  });
};
var AllhomesSuburbStatsGraphQL = _ref2 => {
  var locality = _ref2.locality,
    layout = _ref2.layout,
    props = _objectWithoutProperties(_ref2, _excluded);
  return layout === 'mobile' ? ___EmotionJSX(AllhomesListingSuburbStatsMobile, _extends({}, graphQLToProps({
    division: locality
  }), props)) : ___EmotionJSX(AllhomesListingSuburbStats, _extends({}, graphQLToProps({
    division: locality
  }), props, {
    layout: layout
  }));
};
AllhomesSuburbStatsGraphQL.graphQLToProps = graphQLToProps;
AllhomesSuburbStatsGraphQL.fragment = fragment;
AllhomesSuburbStatsGraphQL.propTypes = {
  locality: PropTypes.shape({
    name: PropTypes.string,
    profile: PropTypes.shape({
      medianSalePrices: PropTypes.shape({
        units: PropTypes.arrayOf(PropTypes.shape({
          period: PropTypes.number,
          medianPrice: PropTypes.number
        })),
        nonUnits: PropTypes.arrayOf(PropTypes.shape({
          period: PropTypes.number,
          medianPrice: PropTypes.number
        }))
      })
    })
  }).isRequired,
  layout: PropTypes.oneOf(['default', 'tabbed', 'mobile']),
  underline: PropTypes.bool
};
AllhomesSuburbStatsGraphQL.defaultProps = {
  layout: 'default',
  underline: false
};
export default AllhomesSuburbStatsGraphQL;